import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * Redirects /discord/claim/:draftId to /student/home?discordClaim=draftId
 * so the home page handles course selection (popup if 2+ courses) and then
 * redirects to the activity page with the claim form.
 */
function DiscordClaimRedirect() {
  const { draftId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (draftId) {
      navigate(`/student/home?discordClaim=${encodeURIComponent(draftId)}`, { replace: true });
    } else {
      navigate("/student/home", { replace: true });
    }
  }, [draftId, navigate]);

  return null;
}

export default DiscordClaimRedirect;
